import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Select, Button, Upload, Row, Col, Switch, InputNumber, message, Avatar } from 'antd';
import { UserOutlined, UploadOutlined } from '@ant-design/icons';
import api from '../../services/api';
import CepInput from '../../components/CepInput';

const { Option } = Select;

const PlayerProfile = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [player, setPlayer] = useState(null);

  const skillLevels = [
    { value: 'iniciante', label: 'Iniciante' },
    { value: 'recreativo', label: 'Recreativo' },
    { value: 'intermediario', label: 'Intermediário' },
    { value: 'avancado', label: 'Avançado' },
    { value: 'semi_pro', label: 'Semi-pro' }
  ];

  const positions = [
    { value: 'goleiro', label: 'Goleiro' },
    { value: 'zagueiro', label: 'Zagueiro' },
    { value: 'lateral', label: 'Lateral' },
    { value: 'volante', label: 'Volante' },
    { value: 'meia', label: 'Meia' },
    { value: 'atacante', label: 'Atacante' },
    { value: 'qualquer', label: 'Qualquer' }
  ];

  useEffect(() => {
    loadPlayerData();
  }, []);

  const loadPlayerData = async () => {
    try {
      // Primeiro tentar buscar do servidor
      const response = await api.get('/community/players/profile', {
        headers: { Authorization: `Bearer ${localStorage.getItem('community_token')}` }
      });
      
      const playerData = response.data;
      console.log('Dados do perfil carregados:', playerData);
      setPlayer(playerData);
      
      // Usar dados reais sem sobrescrever com valores padrão
      form.setFieldsValue(playerData);
      
      // Atualizar localStorage com dados completos
      localStorage.setItem('community_user', JSON.stringify(playerData));
    } catch (error) {
      console.error('Erro ao carregar perfil:', error);
      // Fallback para localStorage se API falhar
      const userData = localStorage.getItem('community_user');
      if (userData) {
        const playerData = JSON.parse(userData);
        console.log('Dados do localStorage:', playerData);
        setPlayer(playerData);
        form.setFieldsValue(playerData);
      } else {
        message.error('Erro ao carregar dados do perfil');
      }
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = { ...values, is_available: values.is_public };
      const response = await api.put('/community/players/profile', payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('community_token')}` }
      });
      
      const updatedPlayer = response.data;
      localStorage.setItem('community_user', JSON.stringify(updatedPlayer));
      setPlayer(updatedPlayer);
      
      // Atualizar form com dados retornados do servidor
      form.setFieldsValue(updatedPlayer);
      
      message.success('Perfil atualizado com sucesso!');
    } catch (error) {
      message.error('Erro ao atualizar perfil');
    }
    setLoading(false);
  };

  const handleAcceptTerms = async () => {
    try {
      await api.post('/community/players/accept-terms', {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('community_token')}` }
      });
      
      message.success('Termos aceitos!');
      loadPlayerData();
    } catch (error) {
      message.error('Erro ao aceitar termos');
    }
  };

  if (!player) return <div>Carregando...</div>;

  return (
    <div style={{ 
      padding: window.innerWidth < 768 ? '8px' : '20px', 
      maxWidth: window.innerWidth < 768 ? '100%' : 800, 
      margin: '0 auto'
    }}>
      <Card 
        title="Meu Perfil"
        size={window.innerWidth < 768 ? 'small' : 'default'}
      >
        <div style={{ 
          textAlign: 'center', 
          marginBottom: window.innerWidth < 768 ? 16 : 24 
        }}>
          <Avatar 
            size={window.innerWidth < 768 ? 80 : 100} 
            src={player.profile_photo} 
            icon={<UserOutlined />} 
          />
        </div>

        {!player.accepted_terms && (
          <Card 
            type="inner" 
            size={window.innerWidth < 768 ? 'small' : 'default'}
            style={{ 
              marginBottom: window.innerWidth < 768 ? 16 : 24, 
              background: '#fff7e6' 
            }}
          >
            <p style={{ fontSize: window.innerWidth < 768 ? 13 : 14 }}>
              <strong>Aceite os Termos de Uso</strong>
            </p>
            <p style={{ fontSize: window.innerWidth < 768 ? 12 : 14 }}>
              Para usar a comunidade, você precisa aceitar nossos termos de uso e política de privacidade.
            </p>
            <Button 
              type="primary" 
              size={window.innerWidth < 768 ? 'small' : 'default'}
              onClick={handleAcceptTerms}
            >
              Aceitar Termos
            </Button>
          </Card>
        )}

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={24} md={12}>
              <Form.Item name="name" label="Nome" rules={[{ required: true }]}>
                <Input size={window.innerWidth < 768 ? 'small' : 'default'} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="phone" label="Telefone">
                <Input size={window.innerWidth < 768 ? 'small' : 'default'} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={12} sm={12} md={6}>
              <Form.Item name="age" label="Idade" rules={[{ required: true, type: 'number', min: 16, max: 60 }]}>
                <InputNumber 
                  style={{ width: '100%' }} 
                  placeholder="25" 
                  min={16} 
                  max={60}
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Form.Item name="search_radius_km" label={window.innerWidth < 768 ? 'Raio (km)' : 'Raio de Busca (km)'}>
                <InputNumber 
                  min={1} 
                  max={50} 
                  style={{ width: '100%' }}
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="preferred_position" label="Posição" rules={[{ required: true }]}>
                <Select
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                >
                  {positions.map(pos => (
                    <Option key={pos.value} value={pos.value}>{pos.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item name="skill_level" label="Nível" rules={[{ required: true }]}>
                <Select size={window.innerWidth < 768 ? 'small' : 'default'}>
                  {skillLevels.map(level => (
                    <Option key={level.value} value={level.value}>{level.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="game_price"
                label={window.innerWidth < 768 ? 'Valor/Jogo (opcional)' : 'Valor por jogo — opcional (R$)'}
                extra="Deixe em branco se joga de graça. Se cobra pra ir jogar (comum pra goleiro), coloque quanto."
              >
                <InputNumber
                  style={{ width: '100%' }}
                  placeholder="ex: 50"
                  min={0}
                  precision={2}
                  addonBefore="R$"
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item name="city" label="Cidade" rules={[{ required: true }]}>
                <Input size={window.innerWidth < 768 ? 'small' : 'default'} />
              </Form.Item>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Form.Item name="state" label="Estado">
                <Input size={window.innerWidth < 768 ? 'small' : 'default'} />
              </Form.Item>
            </Col>
            <Col xs={12} sm={6} md={12}>
              <Form.Item name="neighborhood" label="Bairro">
                <Input size={window.innerWidth < 768 ? 'small' : 'default'} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={24} md={8}>
              <Form.Item name="cep" label="CEP" rules={[{ required: true }]}>
                <CepInput
                  value={form.getFieldValue('cep')}
                  onChange={(value) => form.setFieldsValue({ cep: value })}
                  onAddressChange={(addressData) => {
                    form.setFieldsValue({
                      address: addressData.address,
                      city: addressData.city,
                      state: addressData.state,
                      neighborhood: addressData.neighborhood,
                      latitude: addressData.latitude,
                      longitude: addressData.longitude
                    });
                  }}
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                  placeholder="00000-000"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={16}>
              <Form.Item name="address" label={window.innerWidth < 768 ? 'Endereço' : 'Endereço Completo'}>
                <Input 
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                  disabled
                  placeholder="Será preenchido automaticamente"
                />
              </Form.Item>
            </Col>
          </Row>

          {window.innerWidth >= 768 && (
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Form.Item name="latitude" label="Latitude">
                  <InputNumber style={{ width: '100%' }} precision={8} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="longitude" label="Longitude">
                  <InputNumber style={{ width: '100%' }} precision={8} disabled />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Form.Item
            name="bio"
            label="Bio"
            extra="Aparece no seu perfil público — quem visitar sua URL vê essa mensagem. Escreve algo bacana!"
          >
            <Input.TextArea
              rows={window.innerWidth < 768 ? 3 : 4}
              maxLength={280}
              showCount
              placeholder="Ex: Boleiro de terça e quinta, meia atacante, prefiro society. Bora jogar!"
              size={window.innerWidth < 768 ? 'small' : 'default'}
            />
          </Form.Item>

          <Row gutter={window.innerWidth < 768 ? [8, 8] : [24, 24]}>
            <Col xs={24}>
              <Form.Item
                name="is_public"
                label="Público"
                extra="Aparece no mapa e recebe convites. Se desativar, some do mapa e ninguém pode te convidar."
                valuePropName="checked"
              >
                <Switch
                  size={window.innerWidth < 768 ? 'small' : 'default'}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading} 
              size={window.innerWidth < 768 ? 'default' : 'large'} 
              block
            >
              Salvar Perfil
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default PlayerProfile;